import type { ComputedRef, InjectionKey } from "vue";

export const CreateInjectionKey = Symbol("Create") as InjectionKey<ComputedRef<boolean>>;
export const DisableEventInjectionKey = Symbol("DisableEventInjectionKey") as InjectionKey<
  ComputedRef<boolean>
>;
export const BadgeColorInjectionKey = Symbol("BadgeColor") as InjectionKey<string>;

export const DisabledStateInjectionKey = Symbol("DisabledState") as InjectionKey<boolean>;
